import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/components/seo/content-page";
import { pickContent } from "@/assets/generated";
import { seoMeta } from "@/lib/seo/head";

export const Route = createFileRoute("/funzionalita/redazione-assistita")({
  head: () => seoMeta({
    title: "Redazione assistita di atti e contratti con AI",
    description: "Genera bozze di atti, contratti e pareri con istruzioni in italiano. Editor professionale, oltre 40 template, export PDF A4.",
    path: "/funzionalita/redazione-assistita",
  }),
  component: () => (
    <ContentPage
      eyebrow="Funzionalità"
      title="Redazione assistita: bozze legali in minuti"
      lead="Descrivi cosa ti serve: LexAIPro genera la bozza in formato professionale, con struttura corretta, riferimenti normativi e linguaggio adatto al destinatario."
      tldr="Istruzione in italiano + parametri della pratica → bozza editabile + export PDF A4 con layout legale."
      breadcrumbs={[{name:"Home",path:"/"},{name:"Funzionalità",path:"/funzionalita/redazione-assistita"},{name:"Redazione assistita",path:"/funzionalita/redazione-assistita"}]}
      sections={[
        { heading: "Cosa puoi redigere", bullets: [
          "Atti giudiziari (citazioni, ricorsi, comparse, memorie)",
          "Contratti (compravendita, locazione, NDA, lavoro, servizi)",
          "Pareri legali strutturati",
          "Diffide, lettere di messa in mora, comunicazioni formali",
          "Verbali di assemblea, statuti, patti parasociali",
        ] },
        { heading: "Editor professionale", body: "Editor TipTap con toolbar dedicata: titoli, numerazione legale, citazioni, formattazione conforme alla prassi forense italiana." },
        { heading: "Export PDF A4", body: "Generazione server-side con layout A4, font serif, paginazione, intestazione e piè di pagina personalizzabili. Pronto per la firma." },
      ]}
      faq={[
        { q: "Posso modificare la bozza?", a: "Sì, l'editor è completo. L'AI è un punto di partenza, tu mantieni il controllo." },
        { q: "Posso salvare modelli?", a: "Sì. Puoi creare template riutilizzabili dello studio." },
      ]}
      cta={{ label: "Genera la prima bozza", to: "/signup" }}
      heroImage={pickContent(36)}
      updated="2026"
    />
  ),
});
